









































import Vue from "vue";
import Component from "vue-class-component";
import { Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";

import CouponDetail from "@/components/coupon/CouponDetail.vue";

const couponModule = namespace("coupon");

@Component({
	components: {
		CouponDetail,
	},
})
export default class CouponInfo extends Vue {
  @couponModule.State("infoStatus") infoStatus!: number;
  @couponModule.State("infoName") infoName!: string;

	get couponName() {
		return this.$store.state.couponCreat.couponInfo.couponName;
	}
	set couponName(value: any) {
		this.$store.commit("couponCreat/updateMessage", value);
	}
	injection() {
		this.$router.push(
			"/coupon/injection?id=" +
				this.$route.params.id +
				"&name=" +
				this.infoName
		);
	}
	onCopyClick() {
		this.$router.push(`/coupon/copy/${this.$route.params.id}`);
	}
}
